import { ToggleButtonGroup } from "@mui/material";
import {
  CoinVerticalIcon,
  StarIcon,
  HeartIcon,
  TagIcon,
} from "@phosphor-icons/react";
import { useTranslations } from "use-intl";

import { SortButton } from "@/components/SortButton/SortButton";
import {
  HotelsSortOptions,
  type HotelsSortValue,
} from "@/features/hotels/types/types";
import { SortOrder } from "@/types/enums";

type Props = {
  value: HotelsSortValue;
  onChange: (newValue: HotelsSortValue) => void;
};

function HotelsListsSort({ value, onChange }: Props) {
  const t = useTranslations();

  return (
    <ToggleButtonGroup
      orientation="vertical"
      fullWidth
      exclusive
      size="small"
      color="primary"
      aria-label={t("sortOptions")}
    >
      <SortButton
        value={{ field: HotelsSortOptions.RECOMMENDED, order: SortOrder.ASC }}
        isSelected={
          value.field === HotelsSortOptions.RECOMMENDED &&
          value.order === SortOrder.ASC
        }
        onChange={onChange}
      >
        <HeartIcon
          size={20}
          className="fill-secondary"
          weight="bold"
          aria-hidden
        />
        {t("hotels.filters.recommendedFirst")}
      </SortButton>

      <SortButton
        value={{ field: HotelsSortOptions.SPECIALDEAL, order: SortOrder.ASC }}
        isSelected={
          value.field === HotelsSortOptions.SPECIALDEAL &&
          value.order === SortOrder.ASC
        }
        onChange={onChange}
      >
        <TagIcon
          size={20}
          className="fill-secondary"
          weight="bold"
          aria-hidden
        />
        {t("hotels.filters.specialDealFirst")}
      </SortButton>

      <SortButton
        value={{ field: HotelsSortOptions.PRICE, order: SortOrder.ASC }}
        isSelected={
          value.field === HotelsSortOptions.PRICE &&
          value.order === SortOrder.ASC
        }
        onChange={onChange}
      >
        <CoinVerticalIcon
          size={20}
          className="fill-secondary"
          weight="bold"
          aria-hidden
        />
        {t("hotels.filters.cheapestFirst")}
      </SortButton>

      <SortButton
        value={{ field: HotelsSortOptions.RATING, order: SortOrder.DESC }}
        isSelected={
          value.field === HotelsSortOptions.RATING &&
          value.order === SortOrder.DESC
        }
        onChange={onChange}
      >
        <StarIcon
          size={20}
          className="fill-secondary"
          weight="bold"
          aria-hidden
        />
        {t("hotels.filters.ratingFirst")}
      </SortButton>
    </ToggleButtonGroup>
  );
}

export default HotelsListsSort;
